






























import Vue from 'vue';
import EventBus from '@/helpers/event-bus';
import { FETCH_RECENT_SAVES } from '@/store/action-types';
import { LOAD_STATE } from '@/store/shared';
import { ISession } from '@/store/types';
import MiniSession from '@/components/CancelAnalytics/MiniSession.vue';
import SmallListLoader from '@/components/UI/Loader/SmallListLoader.vue';

export default Vue.extend({
  name: 'RecentSaves',
  components: {
    MiniSession,
    SmallListLoader,
  },
  data() {
    return {
      numDisplayed: 4,
    };
  },
  mounted() {
    EventBus.$on('dashboard-overall-loaded', () => {
      Vue.nextTick(this.resize);
    });
  },
  async created() {
    this.$store.dispatch(FETCH_RECENT_SAVES);
  },
  computed: {
    sessions(): ISession[] {
      return this.$store.state.recentSaves;
    },
    loading(): boolean {
      return this.$store.state.recentSavesLoadState !== LOAD_STATE.LOADED;
    },
  },
  methods: {
    resize() {
      if (!this.loading) {
        const perItemHeight = 60;
        try {
          // @ts-ignore
          const availableHeight = document.getElementById('recent-saves-container')?.clientHeight || 500;
          // @ts-ignore
          const usedHeight = document.getElementById('recent-saves').clientHeight;
          if (availableHeight && usedHeight && availableHeight - usedHeight > perItemHeight) {
            const canAdd = Math.floor((availableHeight - usedHeight) / perItemHeight);
            this.numDisplayed += canAdd;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
});
